import { render, staticRenderFns } from "./AppProgramaMaterial.vue?vue&type=template&id=7efcd529&"
import script from "./AppProgramaMaterial.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports